<script setup lang="ts">
import { computed } from 'vue'
import MmButton from '~/components/mm/base/MmButton.vue'
import MmIcon from '~/components/mm/base/MmIcon.vue'
import MmFeedbackState from '~/components/mm/base/MmFeedbackState.vue'
import brandMark from '~/components/mm/shell/brand.png'
const props = defineProps<{ error?: { statusCode?: number; message?: string } }>()
const { t } = useI18n()
const notFound = computed(() => props.error?.statusCode === 404)
// Technical messages may contain framework codes or private request details.
// Keep recovery copy predictable; diagnostics stay in the error reporting layer.
const retry = () => window.location.reload()
</script>

<template>
  <div class="error-page mm-root">
    <header class="error-header"><a class="brand" href="/" :aria-label="t('t24a.homeLink')"><img :src="brandMark" alt="" width="32" height="32"><span>Music<b>Mint</b></span></a></header>
    <main class="error-content">
      <MmFeedbackState page heading="h1" kind="error" :illustration="notFound ? 'not-found' : 'error'" :title="t(notFound ? 'error.notFoundTitle' : 'error.title')" :description="t(notFound ? 'error.notFoundMessage' : 'error.defaultMessage')">
        <MmButton v-if="!notFound" @click="retry"><MmIcon name="repeat" :size="18" />{{ t('common.retry') }}</MmButton>
        <a href="/" class="btn" :class="notFound ? 'btn-primary' : 'btn-secondary'">{{ t('error.backToHome') }}<MmIcon name="right" :size="18" /></a>
      </MmFeedbackState>
    </main>
  </div>
</template>

<style scoped>
.error-page { min-height: 100dvh; display: flex; flex-direction: column; background: var(--bg); color: var(--text); padding: 0 var(--gutter) var(--safe-b); }
.error-header { display: flex; align-items: center; width: 100%; max-width: 1360px; margin-inline: auto; min-height: var(--header-h, 64px); padding-block: var(--s-4); border-bottom: 1px solid var(--line); }
.error-content { flex: 1; display: grid; place-items: center; width: 100%; max-width: 640px; margin: auto; padding-block: var(--s-12); }
.error-content :deep(.mm-feedback) { width: 100%; }
</style>
